import { render, staticRenderFns } from "./AddNewBundle.vue?vue&type=template&id=b1521444&"
import script from "./AddNewBundle.vue?vue&type=script&lang=js&"
export * from "./AddNewBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports